import React from "react";
import { CountryFlag } from "@/components/black1of1/CountryFlag";

/**
 * FoilBody — explicit stacked-sibling silver crumple foil body.
 *
 * Instead of relying on background-blend-mode (which was being
 * suppressed inside multi-wrapper nesting), each material layer is a
 * separate absolutely-positioned sibling with its own z-index.
 *
 *   z=0  bright silver base
 *   z=1  local SVG crumple texture (soft-light via mix-blend-mode)
 *   z=2  diagonal sheen highlight
 *   z=3  country flag  +  "1 / 1" motif  (content)
 */
export function FoilBody({ countryCode, showOneOfOne = true, className = "" }) {
  const textureUrl = "/textures/silver-foil.svg?v=4";
  return (
    <div className={`absolute inset-0 overflow-hidden ${className}`}>
      {/* Base bright silver */}
      <div
        className="absolute inset-0 z-[1]"
        style={{
          backgroundImage:
            "linear-gradient(135deg, #a8aaad 0%, #d8dadd 18%, #f0f1f3 40%, #c8cacd 58%, #e8e9eb 76%, #98a0a3 100%)",
        }}
      />
      {/* SVG crumple texture — primary, strong contrast */}
      <div
        className="absolute inset-0 z-[2]"
        style={{
          backgroundImage: `url("${textureUrl}")`,
          backgroundSize: "160%",
          backgroundPosition: "center",
          mixBlendMode: "overlay",
          opacity: 1,
        }}
      />
      {/* Secondary texture pass — visible fold detail */}
      <div
        className="absolute inset-0 z-[3] pointer-events-none"
        style={{
          backgroundImage: `url("${textureUrl}")`,
          backgroundSize: "280%",
          backgroundPosition: "25% 65%",
          mixBlendMode: "hard-light",
          opacity: 0.7,
        }}
      />
      {/* Diagonal specular sheen */}
      <div
        className="absolute inset-0 z-[4] pointer-events-none"
        style={{
          backgroundImage:
            "linear-gradient(315deg, rgba(255,255,255,0.35) 0%, rgba(255,255,255,0) 45%, rgba(255,255,255,0.25) 100%)",
          mixBlendMode: "screen",
        }}
      />
      {/* Flag + 1/1 motif */}
      <div className="absolute inset-0 z-[10] flex items-center justify-center pointer-events-none">
        <CountryFlag
          cc={countryCode}
          className="w-[72%] h-auto aspect-[4/3] rounded-md ring-2 ring-black/50 shadow-[0_10px_28px_-6px_rgba(0,0,0,0.7)]"
        />
      </div>
      {showOneOfOne && (
        <div className="absolute top-2 left-1/2 -translate-x-1/2 z-[10] text-[11px] md:text-xs font-display tracking-[0.4em] text-black/85 font-black pointer-events-none">
          1 / 1
        </div>
      )}
    </div>
  );
}
